import React, { forwardRef } from 'react';
// import { useTranslation } from 'react-i18next';
const TabsRender = forwardRef((props, videoRef) => {
  const tabItem = props.item;
  const activeType = props.activeType;
  return (
    <span
      className={`tab ${activeType === tabItem ? 'active' : ''}`}
      onClick={(e) => {
        e.stopPropagation();
        props.changeType(tabItem);
      }}
    >
      {tabItem}
    </span>
  );
});

export default TabsRender;
